import React, { useMemo } from 'react';
import { FormMultiSelect, FormSelect } from 'shared/formControls';
import { useGetMarkets } from 'src/fetch/markets';

const emptyArray = [];

const MarketsDropdown = ({
  hasAllOption,
  showDeleted = false,
  allOptionName,
  ...props
}) => {
  const { data: markets = emptyArray } = useGetMarkets();
  const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;

  const innerMarkets = useMemo(() => {
    let innerData = [...markets];
    const allOption = allOptionName || 'All';

    if (showDeleted === false) {
      innerData = innerData?.filter((m) => m.isDeleted === false);
    }

    if (hasAllOption) {
      if (!innerData.some(({ value, id }) => value === '-all-' || id === '-all-')) {
        innerData.unshift({ id: '-all-', value: '-all-', abbreviation: allOption });
      }
    }

    return innerData;
  }, [markets, showDeleted, hasAllOption, allOptionName]);

  return <SelectComponent data={innerMarkets} textField='abbreviation' dataItemKey='id' {...props} />;
};

export default MarketsDropdown;
